import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** checkmark. Decorative line icon; always pair with a visible text label. */
export function CheckIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4.5 12.5l5 5L19.5 7" />
    </IconSvg>
  )
}
